import dayjs from "dayjs";

export const dateFormat = (value, format = "MM-DD HH:mm") =>
  value ? dayjs(value).format(format) : "";

export default {
  install(Vue) {
    Vue.filter("dateFormat", dateFormat);
  }
};
